import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';
import { isNotNil } from 'shared/src/utils';

export const useGoodsOptions = (params: {
  depth: number;
  selected_option_sno?: number;
}) => {
  const goodsSno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsOptions(goodsSno, params),
    queryFn: () => {
      return goodsService.getGoodsOptions(goodsSno, params);
    },
    enabled: params.depth === 1 || isNotNil(params.selected_option_sno),
  });
};
